import type { ReactNode } from 'react';
import { useState } from 'react';

import { MessagingContext, MessagingProvider } from '@sorare/wallet-shared';

import { Wallet } from './Wallet';
import { WALLET_URL } from '../../config';

interface Props {
  children: ReactNode;
}

export const WalletProvider = ({ children }: Props) => {
  const [window, setWindow] = useState<Window | undefined>(undefined);

  return (
    <MessagingProvider
      Context={MessagingContext}
      allowedOrigins={[WALLET_URL]}
      target={{ window, origin: WALLET_URL }}
    >
      <Wallet setWindow={setWindow}>{children}</Wallet>
    </MessagingProvider>
  );
};
